import type { UpdateProductRequest } from '@/api/generated/schemas';
import type { ProductDetailFormValues } from './productDetailFormSchema';

/**
 * Transformace hodnot formuláře na API request pro update produktu (název + destinace).
 * Formulář drží bohaté UI objekty destinací, API chce jen `destinationId`. Výsledek je
 * `satisfies UpdateProductRequest` (kompilátor hlídá shodu s BE kontraktem).
 */
export function toProductDetailRequestBody(values: ProductDetailFormValues): UpdateProductRequest {
  return {
    name: values.name.trim(),
    destinationIds: values.destinations.map((destination) => destination.destinationId),
  } satisfies UpdateProductRequest;
}
